import React, { useLayoutEffect, useState } from 'react'
import Post from '../../utils/Post'
import Layout from '../layout'
import SplitScreen from '../page-sections/SplitScreen/SplitScreen'
import VerticalMenu from '../parts/VerticalMenu/VerticalMenu'
import PageSectionHeader from '../parts/PageSectionHeader'
import PageSection from '../page-sections/PageSection'
import ChildNewsPages from '../parts/ChildNewsPages'
import WordPressContent from '../content-blocks/WordPressBasicContentBlocks'
import { useWindowSize } from '../hooks'

/**
 * Represents a page with no template applied.
 */
export default function DefaultPage({ page, children }) {
    const { width } = useWindowSize()
    const [isMenuOpen, setMenuOpen] = useState(false)
    const { link, title, blocks, content } = page

    /**
     * Filter news page if width >=1200
     */
    function filterNewsPage(post) {
        const hideNews = width >= 1200
        return hideNews ? post.isNewsPage === false : true
    }

    /**
     * Prepare menu items for sidebar menu.
     */
    const post = new Post(page)
    const menu = post.getPostList(post.getParent(), {
        filters: [filterNewsPage],
        sortBy: 'title',
        isMenu: true,
    })

    /**
     * Before rendering elements to the page,
     * update menu to be open on desktop screens.
     */
    useLayoutEffect(() => {
        setMenuOpen(width >= 1200)
    }, [width])

    return (
        <Layout url={link} title={title}>
            <SplitScreen>
                <div>
                    <PageSectionHeader
                        className="mobile-only"
                        heading={title}
                        pageTitle
                    />
                    <VerticalMenu
                        title={menu.title}
                        titleLink={menu.link}
                        open={isMenuOpen}
                        setOpen={e => {
                            if (width < 1200) {
                                setMenuOpen(!isMenuOpen)
                            }
                        }}
                        disabled={width >= 1200}
                        items={menu.children}
                    />
                </div>
                <PageSection
                    heading={!width || width >= 1200 ? title : null}
                    pageTitle
                    leftAlign
                    defaultPage>
                    {post.isNewsArchive() ? (
                        <ChildNewsPages items={page.wpChildren.nodes} />
                    ) : (
                        <WordPressContent blocks={blocks} content={content} />
                    )}
                    {children}
                </PageSection>
            </SplitScreen>
        </Layout>
    )
}
